import React, { useState } from "react";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useField, useFormikContext } from "formik";
import { FormControl, FormHelperText } from "@mui/material";
import { at } from "lodash";

const OP = "+";

export default function PhoneField(props: any) {
  const { label, fieldName, ...rest } = props;
  const [, setPhone] = useState("");
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);
  const [touched, error] = at(meta, "touched", "error");

  const isError = touched && error && true;
  const renderHelpText = () => {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  };
  const handleChange = (phone: string, country: CountryData) => {
    setPhone(phone);
    setFieldValue(field.name, OP.concat(phone));
    if (fieldName) setFieldValue(fieldName, country.countryCode);
    if (rest.name === "User.Contact.SecondaryPhone.Phone" && phone.length < 1) {
      setFieldValue("User.Contact.SecondaryPhone", undefined);
    }
  };

  return (
    <>
      <FormControl
        {...rest}
        error={isError}
        componentsProps={{
          typography: {
            fontSize: "11px",
          },
        }}
        sx={{ m: 0 }}        
        labelPlacement="top"
        style={{
          width: "100%",
        }}
      >
        <PhoneInput
          {...rest}
          {...field}
          specialLabel={label}
          inputStyle={{
            width: "100%",
          }}
          excludeCountries={["il"]}
          preferredCountries={["lb"]}
          enableSearch={true}
          country={"lb"}
          value={field.value}
          onChange={handleChange}
        />
        {renderHelpText()}
      </FormControl>
    </>
  );
}
